module.exports = __webpack_public_path__ + "images/default-news-image-60x60.74db58a9.svg";